module.exports = __webpack_public_path__ + "img/Support-skill-132.c17545fd.png";